import { buildAsset, updateAsset, createAsset } from './formActions'

export const submitForm = async (state, formValues) => {
  const { formAssetType, riskProfile, assumptions, isExistingAsset } = state
  const newAsset = buildAsset(formValues, formAssetType, riskProfile, assumptions, isExistingAsset)

  if (CreatingNewAsset(state)) {
    await createAsset(state, newAsset)
  } else {
    await updateAsset(state, newAsset)
  }
}

export const deleteAsset = async (state) => {
  const { crudActions } = state

  const deletedAsset = { ...state.asset }
  const deletedAssetId = deletedAsset?.id || null

  await crudActions.delete(deletedAssetId)
}

export const unlinkAsset = async (state, mode) => {
  await state.crudActions.unlink({ assetID: state.asset.id, mode })
}

const CreatingNewAsset = (state) =>
  Object.keys(state.asset || {}).length === 0
